import { ComponentProps } from 'react';

import { getEmoji } from '@/shared-project-insights';
import { formatLocaleNumerals } from '@/shared-utilities';

import RatingScaleSelect from './project-response-rating-scale-select';

type RatingScaleSelectProps = ComponentProps<typeof RatingScaleSelect>;

/**
 * @param numeralLocale - Project language tag, so a Bangla scale reads ১ ২ ৩
 *   rather than mixing Western digits into the question's own script. Omitted
 *   (email embeds, OG images) keeps the raw value.
 */
export const renderValue = (
  option: RatingScaleSelectProps['options'][0],
  optionRenderType: RatingScaleSelectProps['optionRenderType'],
  options: RatingScaleSelectProps['options'],
  numeralLocale?: string | null
) => {
  switch (optionRenderType) {
    case 'Emoji':
      return getEmoji(+option.value, options.length);
    case 'Star':
      return '★';
    default:
      return formatLocaleNumerals(option.value, numeralLocale);
  }
};

export const getHighlightedRatingValue = (
  value: string,
  tentativeValue?: string
) => value || tentativeValue || '';

export const isRatingValueSelected = (
  optionValue: string,
  highlightedValue: string
) => highlightedValue === optionValue;

export const isStarRatingValueSelected = (
  optionValue: string,
  highlightedValue: string
) => highlightedValue !== '' && Number(optionValue) <= Number(highlightedValue);
